import { newListActions } from "@/store/newLists/newLists.slice";

import { aventureApi } from "./apiService/aventureApi";
import { axiosService } from "./apiService/axiosService";
import { loadingError } from "./error.service";

export const newListApi = aventureApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllList: builder.query({
      queryFn: async (_, { dispatch }) => {
        try {
          const { data } = await axiosService.get("app/list/all");

          dispatch(newListActions.setAllLists(data?.data));

          return { data };
        } catch (error) {
          dispatch(loadingError(error));
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      providesTags: ["lists"],
    }),

    addList: builder.mutation({
      queryFn: async (options, { dispatch }) => {
        try {
          const { data } = await axiosService.post("app/list", options);
          return { data };
        } catch (error) {
          dispatch(loadingError(error));
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      invalidatesTags: ["lists"],
    }),

    deleteList: builder.mutation({
      queryFn: async (id, { dispatch }) => {
        try {
          const { data } = await axiosService.delete(`app/list/${id}`);
          return { data };
        } catch (error) {
          dispatch(loadingError(error));
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      invalidatesTags: ["lists"],
    }),

    addCompaniesToList: builder.mutation({
      queryFn: async (options, { dispatch }) => {
        try {
          const { data } = await axiosService.post("app/list/entity", options);
          return { data };
        } catch (error) {
          dispatch(loadingError(error));
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      invalidatesTags: ["lists"],
    }),

    removeCompaniesFromList: builder.mutation({
      queryFn: async (options, { dispatch }) => {
        try {
          const { data } = await axiosService.delete("app/list/entity", {
            data: options,
          });
          return { data };
        } catch (error) {
          dispatch(loadingError(error));
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      invalidatesTags: ["lists"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useLazyGetAllListQuery,
  useAddListMutation,
  useDeleteListMutation,
  useAddCompaniesToListMutation,
  useRemoveCompaniesFromListMutation,
} = newListApi;

export default newListApi;
